import React, { useContext, useEffect, useRef, useState } from "react";
import SignedInNavbarImproved from "../../SignedInNavbarImproved";
import { debounce } from "lodash";
import Container from "../my_container/Container";
import { Menu } from "@headlessui/react";
import toast from "react-hot-toast";
import { GoSearch } from "react-icons/go";
import { FiChevronDown, FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { authService } from "../../../services/authService";
import BasketService from "../../../services/basketService";
import TopDeals from "../create_basket_page/TopDeals";
import AllItems from "../create_basket_page/AllItems";
import SearchPageEmpty from "../create_basket_page/SearchPageEmpty";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchGrocedyForAll,
  fetchProductFeatureInfo,
  userAdvertsGet,
} from "../../../store/actions";
import { motion } from "framer-motion";
import { setIsPastLogin } from "../../../store/slices/modalSlice";
import RxjsGiftStoreContext from "../../../context/RxjsGiftStoreContext";
import BasketFloatingGiftPane from "../create_basket_page/BasketFloatingGiftPane";
import { useLocation } from "react-router-dom";

const GiftACustomBasket = () => {
  const rxjsStore = useContext(RxjsGiftStoreContext);
  const dispatch = useDispatch();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [basketGroupList, setBasketGroupList] = useState([]);
  const [activeindex, setActiveIndex] = useState(0);
  const [activeindexBut, setActiveIndexBut] = useState(0);
  const [butcherGpList, setButcherGpList] = useState([]);
  const [searchResult, setSearchResult] = useState([]);
  const [searchResultButcher, setSearchResultButcher] = useState([]);
  const [fetchedProducts, setFectchedProducts] = useState([]);
  const [currentSection, setCurrentSection] = useState("");
  const [allProductList, setAllProductList] = useState([]);
  const [allButcherProductList, setAllButcherProductList] = useState([]);
  const [prdId, setPrdId] = useState("");
  const [prdIdBut, setPrdIdBut] = useState("");
  const [fetchedAdvertLinks, setFetchedAdvertLinks] = useState();
  const [fetchedFeatureProduct, setFetchedFeatureProduct] = useState([]);
  const searchRef = React.createRef();
  const searchRefButcher = React.createRef();
  const customerId = authService.getCurrentUserCustomerId();
  const [width, setWidth] = useState(0);
  const [widthBut, setWidthBut] = useState(0);
  const carouselTwo = useRef();
  const carouselTwoBut = useRef();

  const [fetchedAdsInfo, setFetchedAdsInfo] = useState([]);

  const { grocedyForAll } = useSelector((state) => state.masterData);
  const { adverts } = useSelector((state) => state.user);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (location.hash) {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }
    }, 1000); // 100ms delay — adjust if needed

    return () => clearTimeout(timeout); // Clean up timeout
  }, [location]);

  const style = {
    margin: 0,
    top: "auto",
    right: 20,
    bottom: 20,
    left: "auto",
    position: "fixed",
  };

  useEffect(() => {
    advertsFetcher();
  }, []);

  const resetProductGroup = (groupId) => {
    setActiveIndex(groupId);
    const newList = rxjsStore.getProductByGroup(groupId);
    // setAllProductList(newList);
    setCurrentSection(groupId);
    setSearchResult(newList);
  };

  useEffect(() => {
    if (!grocedyForAll) {
      dispatch(fetchGrocedyForAll(customerId ? customerId : "0"))
        .unwrap()
        .catch((err) => {
          return err;
        });
    }

    if (grocedyForAll) {
      setFectchedProducts(grocedyForAll?.product_info);
    }
  }, [grocedyForAll, customerId]);

  useEffect(() => {
    if (fetchedProducts?.length) {
      const pubId = fetchedProducts
        ?.filter((fp) => fp?.product_id === "2")
        .pop();
      setPrdId(pubId?.product_id);
    }
  }, [fetchedProducts]);

  useEffect(() => {
    if (fetchedProducts?.length) {
      const pubId = fetchedProducts
        ?.filter((fp) => fp?.product_id === "3")
        .pop();
      setPrdIdBut(pubId?.product_id);
    }
  }, [fetchedProducts]);

  useEffect(() => {
    dispatch(fetchProductFeatureInfo())
      .unwrap()
      .then((res) => {
        if (!res?.product_feature_info?.length) {
          setFetchedFeatureProduct([]);
        }
        setFetchedFeatureProduct(res?.product_feature_info);
      })
      .catch((err) => err);
  }, []);

  useEffect(() => {
    dispatch(setIsPastLogin(true));
  }, [dispatch]);

  useEffect(() => {
    if (adverts?.length) {
      setFetchedAdvertLinks(adverts);
    }
  }, [adverts]);

  useEffect(() => {
    if (authService.isLogin() && prdId) {
      callApiForAuth();
    }
    rxjsStore.getAllBasketProductList().subscribe((allProduct) => {
      setAllProductList(allProduct);
      setSearchResult(allProduct);
    });

    rxjsStore.getBasketGroupList().subscribe((data) => {
      if (data?.length < 1) {
        callApi();
      } else {
        setBasketGroupList(data);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prdId]);

  useEffect(() => {
    if (authService.isLogin() && prdIdBut) {
      callApiForAuthButcher();
    }
    rxjsStore.getAllButcherProductList().subscribe((allProductBut) => {
      setAllButcherProductList(allProductBut);
      setSearchResultButcher(allProductBut);
    });

    rxjsStore.getButcharGroupList().subscribe((data) => {
      if (data?.length < 1) {
        callApiButcher();
      } else {
        setButcherGpList(data);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prdIdBut]);

  useEffect(() => {
    if (grocedyForAll?.ad_info?.length) {
      setFetchedAdsInfo(grocedyForAll?.ad_info);
    }
  }, [grocedyForAll]);

  const debouncedSearch = React.useRef(
    debounce(async (event) => {
      processSearch(event);
    }, 1500)
  ).current;

  const debouncedSearchBut = React.useRef(
    debounce(async (event) => {
      processSearchBut(event);
    }, 1500)
  ).current;

  function advertsFetcher() {
    try {
      dispatch(userAdvertsGet());
    } catch (err) {
      return err;
    }
  }

  // ==================== for basket ================================

  function callApiForAuth() {
    setIsLoading(true);
    if (prdId) {
      BasketService.getBasketListAuth(prdId)
        .then((data, failed) => {
          if (failed) {
            // return toast.error("error getting products");
          }

          setIsLoading(false);
          const { item_group, items, delivery_charge } = data;
          if (item_group?.length) {
            rxjsStore.setBasketGroupList(item_group);
            rxjsStore.setAllBasketProductList(items);
            let charge = {
              item_id: delivery_charge[0]?.item_id,
              item_total: delivery_charge[0]?.item_rate,
              rate: delivery_charge[0]?.item_rate,
              quantity: 1,
              name: "Delivery charge",
            };
            rxjsStore.setDeliveryChargeBasket(charge);
          }
        })
        .catch((err) => {
          setIsLoading(false);
          // toast.error("Error getting product");
        });
    }
  }

  function callApi() {
    setIsLoading(true);
    BasketService.getBasketList()
      .then((data, failed) => {
        if (failed) {
          return toast.error("error getting products");
        }

        setIsLoading(false);
        const { item_group, items, delivery_charge } = data;
        if (item_group?.length) {
          rxjsStore.setBasketGroupList(item_group);
          rxjsStore.setAllBasketProductList(items);

          let charge = {
            item_id: delivery_charge[0]?.item_id,
            item_total: delivery_charge[0]?.item_rate,
            rate: delivery_charge[0]?.item_rate,
            quantity: 1,
            name: "Delivery charge",
          };
          rxjsStore.setDeliveryChargeBasket(charge);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error("Error getting product");
      });
  }

  // =================== for butcher =================================
  function callApiForAuthButcher() {
    setIsLoading(true);
    if (prdIdBut) {
      BasketService.getButcherListAuth(prdIdBut)
        .then((data, failed) => {
          if (failed) {
            return toast.error("error getting products");
          }

          setIsLoading(false);
          const { item_group, items, delivery_charge } = data;
          if (item_group?.length) {
            rxjsStore.setButcherGroupList(item_group);
            rxjsStore.setAllButchersProductList(items);
            let charge = {
              ...delivery_charge[0],
              item_total: delivery_charge[0]?.item_rate,
              quantity: 1,
              name: "Delivery Charge",
            };
            rxjsStore.setDeliveryChargeButcher(charge);
          }
        })
        .catch((err) => {
          setIsLoading(false);
          return err;
        });
    }
  }

  const scrollLeft = () => {
    document.getElementById("content").scrollLeft -= 200;
  };
  const scrollRight = () => {
    document.getElementById("content").scrollLeft += 200;
  };

  const scrollLeftBut = () => {
    document.getElementById("content").scrollLeft -= 200;
  };
  const scrollRightBut = () => {
    document.getElementById("content").scrollLeft += 200;
  };

  function callApiButcher() {
    setIsLoading(true);
    BasketService.getButcherList()
      .then((data, failed) => {
        if (failed) {
          return toast.error("error getting products");
        }

        setIsLoading(false);
        const { item_group, items, delivery_charge } = data;
        if (item_group?.length) {
          rxjsStore.setButcherGroupList(item_group);
          rxjsStore.setAllButchersProductList(items);
          let charge = {
            ...delivery_charge[0],
            item_total: delivery_charge[0]?.item_rate,
            quantity: 1,
            name: "delivery charge",
          };
          rxjsStore.setDeliveryChargeButcher(charge);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        return err;
      });
  }

  useEffect(() => {
    setWidth(
      carouselTwo.current.scrollWidth - carouselTwo.current.offsetWidth - 100
    );
  }, []);

  useEffect(() => {
    setWidthBut(
      carouselTwoBut.current.scrollWidth - carouselTwoBut.current.offsetWidth - 100
    );
  }, []);

  // ===================================================

  // const resetProductGroup = (groupId) => {
  //   const newList = rxjsStore.getProductByGroup(groupId);
  //   // setAllProductList(newList);
  //   setCurrentSection(groupId);
  //   setSearchResult(newList);
  // };

  function processSearch(event) {
    const search = event.target.value;
    // setSearchTextInput(search);

    setCurrentSection(search);

    if (search.length < 2) {
      setCurrentSection("");
      rxjsStore.getAllBasketProductList().subscribe((allProduct) => {
        setAllProductList(allProduct);
        setSearchResult(allProduct);
      });
      return;
    } else if (search.length > 2) {
      var tempResult = rxjsStore.handleSearchProduct(search);
      setSearchResult(tempResult);
    }
  }

  // const resetProductGroupBut = (groupId) => {
  //   const newList = rxjsStore.getButcherByGroup(groupId);
  //   setCurrentSection(groupId);
  //   setSearchResultButcher(newList);
  // };

  const resetProductGroupBut = (groupId) => {
    setActiveIndexBut(groupId);
    const newList = rxjsStore.getButcherByGroup(groupId);
    // setAllProductList(newList);
    setCurrentSection(groupId);
    setSearchResultButcher(newList);
  };

  function processSearchBut(event) {
    const search = event.target.value;
    setCurrentSection(search);
    if (search.length < 2) {
      setCurrentSection("");
      rxjsStore.getAllButcherProductList().subscribe((allProduct) => {
        setAllButcherProductList(allProduct);
        setSearchResultButcher(allProduct);
      });
    } else if (search.length > 2) {
      var tempResult = rxjsStore.handleSearchProductButchers(search);
      setSearchResultButcher(tempResult);
    }
  }

  return (
    <>
      <SignedInNavbarImproved />
      <div className="bg-[#F5F5F5] pb-60">
        <Container className="pt-8">
          <div id="pickBasket" className="mt-6 rounded-2xl border-[1px] border-gray-100 bg-white px-4 py-6 shadow-md">
            <div>
              <div className="mt-6 flex items-center justify-between">
                <h2 className="text-xl font-bold text-gray-800 ">
                  Basket Items
                </h2>

              </div>
              <div className="flex mt-4">
                <section className="my-2 w-full mb-[6rem]">
                  <motion.div
                    ref={carouselTwo}
                    whileTap={{ cursor: "grabbing" }}
                    className=" relative overflow-hidden"
                  >
                    <div className="absolute -right-5 top-0 z-20 h-[70px] w-8 bg-white blur" />
                  </motion.div>

                  {/* DDDFDFDFDFF */}
                  <div className="group relative overflow-hidden">
                    <div
                      id="content"
                      className="carousel flex items-center justify-start overflow-x-auto scroll-smooth px-16 py-4  scrollbar-hide"
                    >
                      {basketGroupList.map((item, index) => {
                        return (
                          <div
                            key={index}
                            onClick={() => resetProductGroup(item?.group_id)}
                            className={`mr-2 min-w-fit rounded-md border-[1px] px-6 py-3 text-sm font-medium sm:mr-4 sm:px-12 sm:text-base ${item?.group_id === activeindex
                                ? "border-white bg-olivine-500 text-white"
                                : "cursor-pointer border-olivine-500 border-opacity-50 bg-white text-olivine-500 hover:bg-olivine-200 hover:bg-opacity-60"
                              }`}
                          >
                            {item?.group_name}
                          </div>
                        );
                      })}
                    </div>
                    <div className="absolute -left-1 top-0 z-10 hidden h-[82px] w-14 bg-white blur-sm sm:inline" />
                    <div className="absolute -right-1 top-0 z-10 hidden h-[82px] w-14 bg-white blur-sm sm:inline" />
                    <button
                      onClick={scrollLeft}
                      className="absolute left-0 top-5 z-30 rounded-full bg-gray-100 p-2 shadow-sm shadow-gray-400 hover:bg-gray-200 active:bg-gray-100 sm:ml-1 sm:hidden sm:group-hover:flex"
                    >
                      <FiChevronLeft className="h-6 w-6 text-gray-600" />
                    </button>
                    <button
                      onClick={scrollRight}
                      className="absolute right-0 top-5 z-30 rounded-full bg-gray-100 p-2 shadow-sm shadow-gray-400 hover:bg-gray-200 active:bg-gray-100 sm:mr-1 sm:hidden sm:group-hover:flex"
                    >
                      <FiChevronRight className="h-6 w-6 text-gray-600" />
                    </button>
                  </div>
                </section>
              </div>
              <div className="relative z-10 mx-auto mt-4 w-full max-w-xl lg:-mt-8">
                <input
                  ref={searchRef}
                  onChange={(ev) => {
                    debouncedSearch(ev);
                    // setSearchInputValue(ev.target.value);
                  }}
                  type="text"
                  placeholder="Quick search for anything"
                  className="focus:border-olivine-600 focus:ring-olivine-600 w-full rounded-lg border-gray-300 bg-[#F9F9F9] pl-4 pr-14 text-gray-700 outline-none ring-0 placeholder:font-normal placeholder:text-gray-400 focus:outline-none focus:ring-1"
                />
                <div className="absolute bottom-0 right-0 top-0 my-[1.5px] mr-[1.5px] w-11 rounded-r-md bg-gray-200" />
                <div className="absolute right-3 top-3">
                  <GoSearch className="text-olivine-500 h-5 w-5 cursor-pointer rounded-full" />
                </div>
              </div>
            </div>
            {/* <div className="mt-6 grid gap-6 grid-auto-fit-sm"> */}
            <div className="mt-6 flex flex-col">
              {/* the cards are coming here */}
              {!currentSection && (
                <>
                  <div>
                    <TopDeals allProductList={allProductList} gift type="basket" />
                  </div>
                </>
              )}
              <div>
                {searchResult?.length ? (
                  <AllItems allProductList={searchResult} gift type="basket" />
                ) : (
                  <SearchPageEmpty searchResult={searchResult} />
                )}
              </div>
            </div>
          </div>
        </Container>

        <Container className="mt-4 pt-8">
          <div id="grochill" className="mt-6 rounded-2xl border-[1px] border-gray-100 bg-white px-4 py-6 shadow-md">
            <div>
              <div className="mt-6 flex items-center justify-between">
                <h2  className="text-xl font-bold text-gray-800 ">
                  GroChill Items
                </h2>

                {/* <div className="z-20">
                  <Menu>
                    <Menu.Button className="text-olivine-500 flex flex-row items-center space-x-1">
                      <p className="font-medium">Categories</p>
                      <div className="p- rounded-full p-1 transition duration-200 hover:bg-[#F0F4E7] hover:ring-[1px] hover:ring-gray-200">
                        <FiChevronDown className="h-4 w-4 cursor-pointer" />
                      </div>
                    </Menu.Button>
                    <Menu.Items className="absolute right-14 flex h-full max-h-60 w-60 origin-top-right flex-col divide-y-[1px] divide-gray-200 overflow-y-scroll rounded-lg border-[1px] border-gray-200 bg-white shadow-xl focus:outline-none">
                      {butcherGpList?.length &&
                        butcherGpList.map((category, index) => (
                          <div
                            key={index}
                            onClick={() =>
                              resetProductGroupBut(category?.group_id)
                            }
                            className="cursor-pointer p-1"
                          >
                            <p className="hover:text-olivine-500 rounded-md px-3 py-2 pl-8 text-right text-sm text-gray-500 transition duration-200 hover:bg-[#F0F4E7]">
                              {category?.group_name}
                            </p>
                          </div>
                        ))}
                    </Menu.Items>
                  </Menu>
                </div> */}
              </div>
              <div className="flex mt-6 mb-[4rem]">
                <section className="my-2 w-full">
                  <motion.div
                    ref={carouselTwoBut}
                    whileTap={{ cursor: "grabbing" }}
                    className=" relative overflow-hidden"
                  >
                    <motion.div
                      drag="x"
                      dragConstraints={{ right: 0, left: -widthBut }}
                      className="flex items-center px-8 py-2"
                    ></motion.div>
                    <div className="absolute -right-5 top-0 z-20 h-[70px] w-8 bg-white blur" />
                  </motion.div>
                  <div className="group relative overflow-hidden">
                    <div
                      id="content"
                      className="carousel flex items-center justify-start overflow-x-auto scroll-smooth px-16 py-4  scrollbar-hide"
                    >
                      {butcherGpList.map((item, index) => {
                        return (
                          <div
                            key={index}
                            onClick={() => resetProductGroupBut(item?.group_id)}
                            className={`mr-2 min-w-fit rounded-md border-[1px] px-6 py-3 text-sm font-medium sm:mr-4 sm:px-12 sm:text-base ${item?.group_id === activeindex
                                ? "border-white bg-olivine-500 text-white"
                                : "cursor-pointer border-olivine-500 border-opacity-50 bg-white text-olivine-500 hover:bg-olivine-200 hover:bg-opacity-60"
                              }`}
                          >
                            {item?.group_name}
                          </div>
                        );
                      })}
                    </div>
                    <div className="absolute -left-1 top-0 z-10 hidden h-[82px] w-14 bg-white blur-sm sm:inline" />
                    <div className="absolute -right-1 top-0 z-10 hidden h-[82px] w-14 bg-white blur-sm sm:inline" />
                    <button
                      onClick={scrollLeftBut}
                      className="absolute left-0 top-5 z-30 rounded-full bg-gray-100 p-2 shadow-sm shadow-gray-400 hover:bg-gray-200 active:bg-gray-100 sm:ml-1 sm:hidden sm:group-hover:flex"
                    >
                      <FiChevronLeft className="h-6 w-6 text-gray-600" />
                    </button>
                    <button
                      onClick={scrollRightBut}
                      className="absolute right-0 top-5 z-30 rounded-full bg-gray-100 p-2 shadow-sm shadow-gray-400 hover:bg-gray-200 active:bg-gray-100 sm:mr-1 sm:hidden sm:group-hover:flex"
                    >
                      <FiChevronRight className="h-6 w-6 text-gray-600" />
                    </button>
                  </div>
                </section>
              </div>
              <div className="relative z-10 mx-auto mt-4 w-full max-w-xl lg:-mt-8">
                <input
                  ref={searchRefButcher}
                  onChange={(ev) => {
                    debouncedSearchBut(ev);
                    // setSearchInputValue(ev.target.value);
                  }}
                  type="text"
                  placeholder="Quick search for anything"
                  className="focus:border-olivine-600 focus:ring-olivine-600 w-full rounded-lg border-gray-300 bg-[#F9F9F9] pl-4 pr-14 text-gray-700 outline-none ring-0 placeholder:font-normal placeholder:text-gray-400 focus:outline-none focus:ring-1"
                />
                <div className="absolute bottom-0 right-0 top-0 my-[1.5px] mr-[1.5px] w-11 rounded-r-md bg-gray-200" />
                <div className="absolute right-3 top-3">
                  <GoSearch className="text-olivine-500 h-5 w-5 cursor-pointer rounded-full" />
                </div>
              </div>
            </div>
            {/* <div className="mt-6 grid gap-6 grid-auto-fit-sm"> */}
            <div className="mt-6 flex flex-col">
              {/* the cards are coming here */}
              {!currentSection && (
                <>
                  <div>
                    <TopDeals allProductList={allButcherProductList} gift type="butcher" />
                  </div>
                </>
              )}
              <div>
                {searchResultButcher?.length ? (
                  <AllItems allProductList={searchResultButcher} gift type="butcher" />
                ) : (
                  <SearchPageEmpty searchResultButcher={searchResultButcher} />
                )}
              </div>
            </div>
          </div>
        </Container>
        <section className="flex justify-center bg-red-900">
          <BasketFloatingGiftPane style={style} giftBasket />
        </section>
      </div>
    </>
  );
};

export default GiftACustomBasket;